export const REQUEST_ZOHO_TOKEN = 'REQUEST_ZOHO_TOKEN';
export const RECEIVE_ZOHO_TOKEN = 'RECEIVE_ZOHO_TOKEN';
export const REQUEST_ZOHO_SESSION = 'REQUEST_ZOHO_SESSION';
export const RECEIVE_ZOHO_SESSION = 'RECEIVE_ZOHO_SESSION';
export const DEFAULT_LINK = 'Aucune session créée';